(() => {


const $cbcd529972511e85$var$DEBUG = true;
function $cbcd529972511e85$var$debugLog(...msgs) {
    if ($cbcd529972511e85$var$DEBUG) console.debug(...msgs);
}
function $cbcd529972511e85$var$isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    return rect.top >= 0 && rect.top <= window.scrollY + window.innerHeight;
}
document.addEventListener("DOMContentLoaded", ()=>{
    const mainHeader = document.querySelector(".header-main");
    const languageSwitcher = document.querySelector(".country-selector");
    // Handle main nav
    {
        let HEADER_NAV_STATE = {
            navVisible: false
        };
        if (mainHeader) {
            const ACTIVE_CLASS = "header-main--nav-active";
            function onEscapePress(e) {
                if (e.key === "Escape") hideMenu();
            }
            function showMenu() {
                if (HEADER_NAV_STATE.navVisible) hideMenu();
                else {
                    HEADER_NAV_STATE.navVisible = true;
                    mainHeader?.classList.add(ACTIVE_CLASS);
                    document.addEventListener("keydown", onEscapePress);
                    // translation switch
                    languageSwitcher?.classList.add("text-white");
                    languageSwitcher?.classList.add("hidden");
                    languageSwitcher?.classList.add("sm:block");
                }
            }
            function hideMenu() {
                HEADER_NAV_STATE.navVisible = false;
                mainHeader?.classList.remove(ACTIVE_CLASS);
                document.removeEventListener("keydown", onEscapePress);
                // translation switch
                languageSwitcher?.classList.remove("text-white");
                languageSwitcher?.classList.remove("hidden");
                languageSwitcher?.classList.remove("sm:block");
            }
            const menuToggles = document.querySelectorAll(".header-nav-toggle");
            menuToggles.forEach((el)=>{
                el.removeEventListener("click", showMenu);
                el.addEventListener("click", showMenu);
            });
        }
    }
    // Handle search form toggle
    {
        let HEADER_SEARCH_STATE = {
            inputChanged: false,
            searchActive: false,
            termLength: 0
        };
        const SEARCH_ACTIVE_CLASS = "header-main--search-active";
        const searchToggleButton = document.querySelector(".header-search-toggle");
        const headerSearchForm = document.querySelector(".header-search-form");
        const input = headerSearchForm?.querySelector('input[type="search"]');
        if (searchToggleButton && headerSearchForm && input) {
            function removeOnOutsideClick(e) {
                document.removeEventListener("click", removeOnOutsideClick);
                e.stopImmediatePropagation();
                if (e.target instanceof Node) {
                    if (!headerSearchForm?.contains(e.target)) {
                        toggleSearchForm(e);
                        document.removeEventListener("click", removeOnOutsideClick);
                    } else if (e.target == searchToggleButton || searchToggleButton?.contains(e.target)) {
                        toggleSearchForm(e);
                        document.removeEventListener("click", removeOnOutsideClick);
                    }
                }
            }
            function toggleSearchForm(e) {
                e.stopImmediatePropagation();
                // If we are on mobile, just redirect usr to search page
                if (window.outerWidth < 640) window.location.href = "/search/S\xf6k";
                else // Check if user has entered any text
                if (HEADER_SEARCH_STATE.inputChanged && input?.value) headerSearchForm?.submit();
                else {
                    headerSearchForm?.classList.toggle("pointer-events-none");
                    headerSearchForm?.classList.toggle("opacity-0");
                    headerSearchForm?.classList.toggle("opacity-100");
                    headerSearchForm?.classList.toggle("pointer-events-all");
                    headerSearchForm?.querySelector("input")?.focus();
                    HEADER_SEARCH_STATE.searchActive = !HEADER_SEARCH_STATE.searchActive;
                    if (HEADER_SEARCH_STATE.searchActive) {
                        mainHeader?.classList.add(SEARCH_ACTIVE_CLASS);
                        setTimeout(()=>{
                            document.addEventListener("click", removeOnOutsideClick);
                        }, 100);
                    } else {
                        mainHeader?.classList.remove(SEARCH_ACTIVE_CLASS);
                        document.removeEventListener("click", removeOnOutsideClick);
                    }
                }
            }
            searchToggleButton.addEventListener("click", toggleSearchForm);
            function updateInputOnChange() {
                if (input instanceof HTMLInputElement) {
                    HEADER_SEARCH_STATE.inputChanged = HEADER_SEARCH_STATE.inputChanged || input.value.length > 0;
                    HEADER_SEARCH_STATE.termLength = input.value.length;
                    if (HEADER_SEARCH_STATE.termLength > 25) {
                        input.classList.remove("longer-than-a");
                        input.classList.add("longer-than-b");
                    } else if (HEADER_SEARCH_STATE.termLength > 12) {
                        input.classList.remove("longer-than-b");
                        input.classList.add("longer-than-a");
                    } else {
                        input.classList.remove("longer-than-a");
                        input.classList.remove("longer-than-b");
                    }
                }
            }
            // Listen to input changes
            input.addEventListener("keydown", updateInputOnChange);
            input.addEventListener("change", updateInputOnChange);
            $cbcd529972511e85$var$debugLog("Adding search func...");
        } else $cbcd529972511e85$var$debugLog("No search form in header found.");
    }
    // Handle videos in boxes...
    {
        const videos = document.querySelectorAll(".navigator-box video");
        videos.forEach((videoEl)=>{
            const box = videoEl.closest(".navigator-box");
            const playButtonEl = box?.querySelector(".play-button");
            // const faderEl = box?.querySelector(".video-fader");
            const STATE = {
                // startedManualPlay: false,
                stoppedAtLeastOnce: false
            };
            window.addEventListener("scroll", ()=>{
                if (STATE.stoppedAtLeastOnce) return;
                // do not auto play on small screens...
                if (window.innerWidth < 450) return;
                if ($cbcd529972511e85$var$isElementInViewport(videoEl)) {
                    if (videoEl.paused && !videoEl.ended) videoEl.play();
                }
            }, {
                passive: true
            });
            const headlineText = box?.querySelector(".pill-headline");
            videoEl.addEventListener("play", ()=>{
                playButtonEl && playButtonEl.classList.add("opacity-0");
            });
            // TODO: Handle when the video appears below the main header!
            videoEl.addEventListener("pause", ()=>{
                playButtonEl && playButtonEl.classList.remove("opacity-0");
                STATE.stoppedAtLeastOnce = true;
                if (videoEl.ended) videoEl.load();
                setTimeout(()=>{
                    // mainHeader?.classList.remove("opacity-0");
                    // faderEl?.classList.add("hidden");
                    videoEl.classList.remove("relative");
                    videoEl.classList.remove("z-40");
                    headlineText?.classList.remove("z-50");
                    headlineText?.classList.remove("opacity-0");
                }, 150);
            });
            box?.addEventListener("click", ()=>{
                if (videoEl.paused) {
                    videoEl.scrollIntoView({
                        behavior: "smooth",
                        block: "center"
                    });
                    videoEl.play();
                    // faderEl?.classList.remove("hidden");
                    // mainHeader?.classList.add("opacity-0");
                    setTimeout(()=>{
                        // faderEl?.classList.add("opacity-45");
                        // faderEl?.classList.add("z-30");
                        videoEl.classList.add("relative");
                        videoEl.classList.add("z-40");
                        headlineText?.classList.add("opacity-0");
                    }, 150);
                } else videoEl.pause();
            });
        });
    }
    document.querySelectorAll(".navigator-select-dd").forEach((el)=>{
        if (el instanceof HTMLDivElement) {
            // for positioning
            const relPositionDiv = document.createElement("div");
            relPositionDiv.classList.add("navigator-select-dd");
            relPositionDiv.classList.add("navigator-select-dd--ghost");
            el.after(relPositionDiv);
            const list = el.querySelector("ul");
            const label = el.querySelector("label");
            if (list instanceof HTMLUListElement && label instanceof HTMLLabelElement) {
                const STATE = {
                    OPEN: false
                };
                // hide
                list.classList.add("hidden");
                // toggle func
                el.addEventListener("click", (e)=>{
                    STATE.OPEN = !STATE.OPEN;
                    list.classList.toggle("hidden");
                    el.classList.toggle("navigator-select-dd--active");
                    e.stopImmediatePropagation();
                });
                // close on outside click...
                document.addEventListener("click", (e)=>{
                    if (STATE.OPEN) {
                        STATE.OPEN = false;
                        list.classList.toggle("hidden");
                        el.classList.toggle("navigator-select-dd--active");
                        e.stopImmediatePropagation();
                    }
                });
            }
        }
    });
    // Handle front page top part
    {
        const topPartEl = document.querySelector(".front-page-hero-content");
        const image = topPartEl?.querySelector("img");
        if (topPartEl instanceof HTMLDivElement && image instanceof HTMLImageElement) image.addEventListener("load", ()=>{
            // Make sure el is in view
            if ($cbcd529972511e85$var$isElementInViewport(topPartEl)) {
                topPartEl.style.opacity = "0";
                topPartEl.style.transform = "translateY(50px)";
                setTimeout(()=>{
                    topPartEl.classList.add("transition-all");
                    topPartEl.classList.add("duration-1000");
                }, 10);
                setTimeout(()=>{
                    topPartEl.style.opacity = "1";
                    topPartEl.style.transform = "translateY(0)";
                }, 500);
            }
        });
    }
    document.querySelectorAll("img.parrallax-back").forEach((img)=>{
        if (img instanceof HTMLImageElement) {
            const topPos = getComputedStyle(img).top;
            const intTopPos = parseInt(topPos.replace("px", ""));
            window.addEventListener("scroll", ()=>{
                img.style.top = `${intTopPos + window.scrollY / 3}px`;
            }, {
                passive: true
            });
        }
    });
    // "align" height of headlines at same top positions...
    {
        const h2s = document.querySelectorAll("h2.h2");
        function updateHeadlines() {
            let h2AtPositions = {};
            h2s.forEach((h2)=>{
                const t = h2.offsetTop;
                if (!(t in h2AtPositions)) h2AtPositions[t] = [];
                h2AtPositions[t].push(h2);
            });
            for(const key in h2AtPositions){
                const els = h2AtPositions[key];
                let maxHeight = 0;
                for (const el of els){
                    el.style.minHeight = `0px`;
                    if (el.offsetWidth > 0) maxHeight = Math.max(maxHeight, el.offsetHeight);
                }
                for (const el of els)el.style.minHeight = `${maxHeight}px`;
            }
        }
        window.addEventListener("resize", updateHeadlines, {
            passive: true
        });
        setTimeout(updateHeadlines, 10);
    }
});

})();
//# sourceMappingURL=main.js.map
